import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from "../auth/auth.service";


@Injectable()
export class AuthGuard implements CanActivate {
  private isLogin: boolean = false;


  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.isLogin = this.authService.checkLogin();
    if (this.isLogin) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/shared/services/guards/auth.guard.ts